import { render } from "./App.vue?vue&type=template&id=6faa5a1d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6faa5a1d&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/epica/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__